<template>
  <div class="card accompagnement-card h-100 shadow-sm">
    <div class="card-img-top-wrapper">
      <img
        src="@/assets/img/photo/27205.jpg"
        class="card-img-top"
        :alt="$t('soinsResume.image.alt')"
      />
    </div>

    <div class="card-body d-flex flex-column">
      <h5 class="fw-bold" style="font-size: 1.3rem">
        {{ $t("soinsResume.title") }}
      </h5>

      <p class="text-muted" style="font-size: 1rem; line-height: 1.4">
        {{ $t("soinsResume.text.p1") }}
      </p>

      <a
        href="/soins-bien-etre-socio-esthetique"
        class="btn btn-custom mt-2 w-100 mt-auto"
      >
        {{ $t("soinsResume.button.more") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SoinsResume",
};
</script>

<style></style>
